module.exports = {
	"apiEndpoint": "https://bbyo-api-production.herokuapp.com/api/v1",
	"publicEndpoint": "https://bbyo.onetable.org/",
	"facebookAppId": "920258291402212",
	"stripePublishableKey": "pk_test_umtjH6YlxvIiDv0VKX5JB1vV",
	"amazonUrl": "https://bbyo-tmp-production.s3.amazonaws.com/",
	"googleKey": "AIzaSyB0VgLqty-SkmfMeT33HVO_oLK0SNLOt_g",
	"isOnward": false
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./config-production.json
 ** module id = 234
 ** module chunks = 1
 **/